import React, { useState, useEffect } from 'react';
import image1 from '../img/envision/Leadershipo/ccr.png';
import image2 from '../img/envision/Leadershipo/1706554620347.jpg';
import { FaLinkedin, FaTwitter, FaFacebook, FaInstagram } from 'react-icons/fa';
import AboutLeadershipsecondcontainer from './AboutLeadershipsecondcontainer';
import Footer from './Footer';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
const AboutLeadership = () => {
    const [isHovered1, setIsHovered1] = useState(false);
    const [isHovered2, setIsHovered2] = useState(false);
    const [isHovered3, setIsHovered3] = useState(false);

    const location = useLocation();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [location]); // Run effect when the route changes

    return (
        <div>
            <div style={{ background: "rgb(236 115 34)", marginTop: "80px", height: "63px" }}>
                <h1 style={{ textAlign: "center", paddingTop: "13px" }}>OUR LEADERSHIP</h1>
            </div>
            <div className="container" style={{ padding: '20px', marginTop: '10px' }}>
                <h1 style={{ textAlign: 'center' }}>
                    Executive <span style={{ color: 'rgb(236 115 34)' }}>Leadership</span>
                </h1>
                <div className="row" style={{ justifyContent: "center" }}>
                    <div className="col-lg-4 mb-4">
                        <div
                            style={{
                                textAlign: 'center',
                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                                borderRadius: '8px',
                                overflow: 'hidden',
                                backgroundColor: '#f8f9fa',
                                transition: 'transform 0.3s ease-in-out',
                            }}
                            className="leadership-card"
                        >
                            <Link to="/leadershipmd" style={{ textDecoration: 'none', color: 'inherit' }}>
                                <div
                                    className="bgimg-image-container-2"
                                    style={{
                                        height: '300px',
                                        backgroundColor: '#ccc',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        position: 'relative',
                                    }}
                                    onMouseEnter={() => setIsHovered2(true)}
                                    onMouseLeave={() => setIsHovered2(false)}
                                >
                                    <img
                                        src={image2}
                                        alt="Raghuram"
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            display: 'block',
                                            filter: isHovered2 ? 'none' : 'brightness(0.6)',
                                            transition: 'transform 0.3s ease-in-out',
                                            transform: isHovered2 ? 'scale(1.1)' : 'scale(1)',
                                        }}
                                    />
                                    <div
                                        className="overlay"
                                        style={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            right: 0,
                                            bottom: 0,
                                            backgroundColor: 'rgb(88 84 84 / 40%)',
                                            opacity: isHovered2 ? 0 : 1,
                                            transition: 'opacity 0.3s ease',
                                        }}
                                    ></div>
                                </div>
                                </Link>
                                <div style={{ padding: '15px', background: 'rgb(236 115 34)' }}>
                                    <h4 style={{ margin: '10px 0', color: '#fff', fontSize: '18px' }}>
                                        Raghuram Prasad.K
                                    </h4>
                                    <p
                                        style={{
                                            margin: '5px 0',
                                            color: '#fff',
                                            fontSize: '14px',
                                            transition: 'color 0.3s ease',
                                        }}
                                        className="leadership-text-hover"
                                    >
                                        Founder & CEO
                                    </p>
                                    {/* Social Media Icons */}
                                    <div style={{ marginTop: '10px' }}>
                                        <a
                                            href="https://www.linkedin.com/in/raghuram-prasad-k-30616645/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ color: '#fff', margin: '0 5px' }}
                                        >
                                            <FaLinkedin size={20} />
                                        </a>

                                        <a href="#" style={{ color: '#fff', margin: '0 5px' }}>
                                            <FaTwitter size={20} />
                                        </a>
                                        <a href="#" style={{ color: '#fff', margin: '0 5px' }}>
                                            <FaFacebook size={20} />
                                        </a>
                                        <a href="#" style={{ color: '#fff', margin: '0 5px' }}>
                                            <FaInstagram size={20} />
                                        </a>
                                    </div>
                                </div>
                            
                        </div>
                    </div>

                    {/* Card 1 */}




                    <style>
                        {`
          body, h1, h2, h3, h4, h5, h6, p {
            font-family: "Helvetica Neue", sans-serif !important;
          }
        `}
                    </style>
                    {/* Card 2 */}

                </div>
                <AboutLeadershipsecondcontainer />
            </div>
            <Footer />
        </div>
    );
};

export default AboutLeadership;
